import { render, staticRenderFns } from "./fee-designations.vue?vue&type=template&id=da7d4762&"
import script from "./fee-designations.vue?vue&type=script&lang=ts&"
export * from "./fee-designations.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports